/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloadlinkscolumnname3Inputs */

const en_downloadlinkscolumnname3 = /** @type {(inputs: Downloadlinkscolumnname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

const de_downloadlinkscolumnname3 = /** @type {(inputs: Downloadlinkscolumnname3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Name`)
};

/**
* | output |
* | --- |
* | "Name" |
*
* @param {Downloadlinkscolumnname3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const downloadlinkscolumnname3 = /** @type {((inputs?: Downloadlinkscolumnname3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloadlinkscolumnname3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_downloadlinkscolumnname3(inputs)
	return de_downloadlinkscolumnname3(inputs)
});
export { downloadlinkscolumnname3 as "downloadLinksColumnName" }